import { defineStore } from "pinia"
import { computed, ref } from "vue"

import { PageState } from "~/providers/page/pageState"

export const useDotsStore = defineStore("dots", () => {
  // GRID
  const sharpness = ref(1000)
  const cellSize = ref(1.8)
  const radius = ref(0.0008)
  const brightness = ref(0.65)

  // AMBIENT
  const ambientSpeed = ref(0.5)
  const ambientScale = ref(4)
  const ambientCutoff = ref(0.75)
  const ambientStrength = ref(0.35)

  const ambientMaskTop = ref(0)
  const ambientMaskBottom = ref(0)
  const ambientMaskCenter = ref(0)

  // FLOW MAP
  const flowMapSize = ref(64)
  const flowMapFalloff = ref(0.5)
  const flowMapDissipation = ref(0.985)
  const flowMapStrength = ref(0.5)

  return {
    sharpness,
    cellSize,
    radius,
    brightness,

    ambientSpeed,
    ambientScale,
    ambientCutoff,
    ambientStrength,

    ambientMaskTop,
    ambientMaskBottom,
    ambientMaskCenter,

    flowMapSize,
    flowMapFalloff,
    flowMapDissipation,
    flowMapStrength,
  }
})

// if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot));
